import { z } from "zod";
import { membershipStatusSchema, organizationRoleSchema } from "../enums.js";
import { isoDate, optionalIsoDate } from "./common.js";

export const memberSchema = z.object({
  membershipId: z.string(),
  email: z.string().email(),
  fullName: z.string().nullable(),
  department: z.string().nullable(),
  role: organizationRoleSchema,
  status: membershipStatusSchema,
  invitedByEmail: z.string().email().nullable(),
  createdAt: isoDate,
  activatedAt: optionalIsoDate,
});
export type Member = z.infer<typeof memberSchema>;

export const inviteMemberSchema = z.object({
  email: z.string().email(),
  fullName: z.string().trim().max(200).nullable().optional(),
  department: z.string().trim().max(200).nullable().optional(),
  // A manager can only invite roles they are permitted to grant; enforced server-side.
  role: organizationRoleSchema,
});
export type InviteMemberInput = z.infer<typeof inviteMemberSchema>;

export const updateMemberSchema = z.object({
  fullName: z.string().trim().max(200).nullable().optional(),
  department: z.string().trim().max(200).nullable().optional(),
  role: organizationRoleSchema.optional(),
  status: membershipStatusSchema.optional(),
});
export type UpdateMemberInput = z.infer<typeof updateMemberSchema>;
